import { render } from "./ViewProfilePrivate.vue?vue&type=template&id=3ea84428&scoped=true"
import script from "./ViewProfilePrivate.vue?vue&type=script&lang=js"
export * from "./ViewProfilePrivate.vue?vue&type=script&lang=js"

import "@/Common/Styles/profile.scss?vue&type=style&index=0&id=3ea84428&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea84428"]])

export default __exports__